export const FETCH_NUTRITIONISTS = 'FETCH_NUTRITIONISTS';
export const FETCH_NUTRITIONIST = 'FETCH_NUTRITIONIST';
export const CREATE_NUTRITIONIST = 'CREATE_NUTRITIONIST';
export const UPDATE_NUTRITIONIST = 'UPDATE_NUTRITIONIST';
export const CREATE_NUTRITION_DIPLOMA = 'CREATE_NUTRITION_DIPLOMA';
export const DELETE_NUTRITION_DIPLOMA = 'DELETE_NUTRITION_DIPLOMA';
export const FETCH_NUTRITION_CONSULTATIONS = 'FETCH_NUTRITION_CONSULTATIONS';
export const FETCH_NUTRITION_CONSULTATION = 'FETCH_NUTRITION_CONSULTATION';
export const CREATE_NUTRITION_CONSULTATION = 'CREATE_NUTRITION_CONSULTATION';
export const UPDATE_NUTRITION_CONSULTATION = 'UPDATE_NUTRITION_CONSULTATION';
export const CANCEL_NUTRITION_CONSULTATION = 'CANCEL_NUTRITION_CONSULTATION';
export const COMPLETE_NUTRITION_CONSULTATION = 'COMPLETE_NUTRITION_CONSULTATION';
export const FETCH_NUTRITION_TASKS = 'FETCH_NUTRITION_TASKS';
export const CREATE_NUTRITION_TASK = 'CREATE_NUTRITION_TASK';
export const UPDATE_NUTRITION_TASK = 'UPDATE_NUTRITION_TASK';
export const DELETE_NUTRITION_TASK = 'DELETE_NUTRITION_TASK';
export const UPLOAD_NUTRITION_TASK_FILE = 'UPLOAD_NUTRITION_TASK_FILE';
export const DELETE_NUTRITION_TASK_FILE = 'DELETE_NUTRITION_TASK_FILE';
export const FETCH_NUTRITION_NOTES = 'FETCH_NUTRITION_NOTES';
export const CREATE_NUTRITION_NOTE = 'CREATE_NUTRITION_NOTE';
export const UPDATE_NUTRITION_NOTE = 'UPDATE_NUTRITION_NOTE';
export const DELETE_NUTRITION_NOTE = 'DELETE_NUTRITION_NOTE';
export const FETCH_NUTRITION_FEEDBACKS = 'FETCH_NUTRITION_FEEDBACKS';
export const UPDATE_NUTRITION_FEEDBACK = 'UPDATE_NUTRITION_FEEDBACK';
export const DELETE_NUTRITION_FEEDBACK = 'DELETE_NUTRITION_FEEDBACK';
export const FETCH_NUTRITION_FILTERS = 'FETCH_NUTRITION_FILTERS';
export const CREATE_NUTRITION_FILTER = 'CREATE_NUTRITION_FILTER';
export const UPDATE_NUTRITION_FILTER = 'UPDATE_NUTRITION_FILTER';
export const DELETE_NUTRITION_FILTER = 'DELETE_NUTRITION_FILTER';
export const FETCH_NUTRITION_FEATURES = 'FETCH_NUTRITION_FEATURES';
export const CREATE_NUTRITION_FEATURE = 'CREATE_NUTRITION_FEATURE';
export const UPDATE_NUTRITION_FEATURE = 'UPDATE_NUTRITION_FEATURE';
export const DELETE_NUTRITION_FEATURE = 'DELETE_NUTRITION_FEATURE';
export const FETCH_NUTRITION_AGORA = 'FETCH_NUTRITION_AGORA';
